/* eslint-disable no-new */
import Flickity from 'flickity';

const sliders = [...document.querySelectorAll('.js-slider')];

sliders.forEach((slider) => {
    new Flickity(slider, {
        wrapAround: true,
        prevNextButtons: false,
        groupCells: true,
        adaptiveHeight: true,
        autoPlay: 9500,
        selectedAttraction: 0.01,
    });
});



// WEBPACK FOOTER //
// ./app/scripts/components/slider.js